
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicePage = lazy(() => import('../pages/service/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/service/:serviceId',
    element: <ServicePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
